import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from 'src/app/components/form/input-field/input-field.component';
import { SelectFieldComponent } from 'src/app/components/form/select-field/select-field.component';
import { TextAreaFieldComponent } from 'src/app/components/form/textarea-field/textarea-field.component';
import { ProjectsService } from 'src/app/services/api/projects.service';

interface RtpItem {
  id: number;
  name: string;
  platform: string;
  reportedByClient: string;
  reportedInGame: string;
  verifiedByGlobal: number | '';
  verification: string;
  comment: string;
  nameControl?: FormControl;
  platformControl?: FormControl;
  reportedByClientControl?: FormControl;
  reportedInGameControl?: FormControl;
  verifiedByGlobalControl?: FormControl;
  verificationControl?: FormControl;
  commentControl?: FormControl;
}

@Component({
  selector: 'projects-rtp',
  imports: [
    ReactiveFormsModule,
    InputFieldComponent,
    SelectFieldComponent,
    TextAreaFieldComponent
],
  templateUrl: './projects-rtp.component.html',
  styleUrl: './projects-rtp.component.scss'
})
export class ProjectsRtpComponent implements OnInit {
  @Input() projectId?: string;
  @Output() onRtpUpdated = new EventEmitter<any>();
  
  rtpItems: RtpItem[] = [];
  nextId: number = 1;
  
  platformOptions: { key: string, value: string }[] = [
    { key: 'Desktop', value: 'Desktop' },
    { key: 'Mobile', value: 'Mobile' },
    { key: 'Tablet', value: 'Tablet' },
    { key: 'All', value: 'All' }
  ];
  
  verificationOptions: { key: string, value: string }[] = [
    { key: 'Verified', value: 'Verified' },
    { key: 'Not Verified', value: 'Not Verified' },
    { key: 'Pending', value: 'Pending' }
  ];
 
  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService
  ) {}

  ngOnInit(): void {
    if (this.projectId) {
      this.loadRtpData();
    } else {
      this.addNewItem();
    }
  }

  loadRtpData(): void {
    if (!this.projectId) return;
  
    setTimeout(() => {
      const mockData = [
        {
          id: 1,
          name: 'Across The Universe',
          platform: 'Desktop',
          reportedByClient: 'Client A',
          reportedInGame: 'Game X',
          verifiedByGlobal: 0,
          verification: 'Verified',
          comment: ''
        },
        {
          id: 2,
          name: 'Across The Universe',
          platform: 'Mobile',
          reportedByClient: 'Client B',
          reportedInGame: 'Game Y',
          verifiedByGlobal: 0,
          verification: 'Not Verified',
          comment: ''
        },
        {
          id: 3,
          name: 'Twin Fruits of Santa',
          platform: 'Desktop',
          reportedByClient: 'Client C',
          reportedInGame: 'Game Z',
          verifiedByGlobal: 0,
          verification: 'Pending',
          comment: ''
        }
      ];
      
      this.rtpItems = mockData.map(item => ({
        ...item
      }));
      this.nextId = Math.max(...this.rtpItems.map(item => item.id)) + 1;
      
      this.rtpItems.forEach(item => {
        this.initFormControls(item);
      });
      
      this.emitChanges();
    }, 500);
  }

  createFormControl(item: RtpItem, field: string): FormControl {
    const control = new FormControl(item[field as keyof RtpItem] || '', Validators.required);
    (item as any)[`${field}Control`] = control;
    return control;
  }

  initFormControls(item: RtpItem): void {
    item.nameControl = new FormControl(item.name || '', Validators.required);
    item.platformControl = new FormControl(item.platform || '', Validators.required);
    item.reportedByClientControl = new FormControl(item.reportedByClient || '', Validators.required);
    item.reportedInGameControl = new FormControl(item.reportedInGame || '', Validators.required);
    item.verifiedByGlobalControl = new FormControl(item.verifiedByGlobal ?? '', Validators.required);
    item.verificationControl = new FormControl(item.verification || 'Pending', Validators.required);
    item.commentControl = new FormControl(item.comment || '', Validators.required);
  }

  addNewItem(): void {
    const newItem: RtpItem = {
      id: this.nextId++,
      name: '',
      platform: '',
      reportedByClient: '',
      reportedInGame: '',
      verifiedByGlobal: '',
      verification: 'Pending',
      comment: ''
    };
    
    this.initFormControls(newItem);
    this.rtpItems.push(newItem);
    this.emitChanges();
  }

  removeItem(index: number): void {
    this.rtpItems.splice(index, 1);
    if (this.rtpItems.length === 0) {
      this.addNewItem();
    }
    this.emitChanges();
  }

  updateItemField(item: RtpItem, field: string, value: any): void {
    (item as any)[field] = value;
    this.emitChanges();
  }

  saveRtpData(): void {
    console.log('Salvataggio dati RTP:', this.rtpItems);
    this.emitChanges();
  }

  emitChanges(): void {
    const cleanData = this.rtpItems.map(item => {
      const { nameControl, platformControl, reportedByClientControl, reportedInGameControl, verifiedByGlobalControl, verificationControl, commentControl, ...cleanItem } = item;
      
      return cleanItem;
    });
    
    this.onRtpUpdated.emit({
      type: 'rtp',
      data: {
        items: cleanData
      }
    });
  }
}
